import React from "react";

function SideText() {
  return (
    <aside className='side-text'>
      <a
        href='https://www.instagram.com/erugo.gada/'
        target='_blank'
        rel='noopener noreferrer'
      >
        <span className='side-text__icon'>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M0 0H24V24H0V0ZM18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12ZM19 7C20.1046 7 21 6.10457 21 5C21 3.89543 20.1046 3 19 3C17.8954 3 17 3.89543 17 5C17 6.10457 17.8954 7 19 7Z'
              fill='#1D1D1D'
            />
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M24 0H0V24H24V0ZM17.0526 5.13755L18.3684 6.4476C18.4386 6.51747 18.5614 6.51747 18.6316 6.4476L19.9474 5.13755C20.0175 5.05022 20.0175 4.94542 19.9474 4.87555L18.6316 3.5655C18.5614 3.47817 18.4386 3.47817 18.3684 3.5655L17.0526 4.87555C16.9825 4.94542 16.9825 5.05022 17.0526 5.13755ZM9.33046 5.58388C9.71306 5.47321 14.2496 5.44554 14.6868 5.66688C15.1241 5.88822 18.2941 8.84864 18.4308 9.18065C18.5947 9.485 19.114 13.8841 18.9773 14.3268C18.8407 14.7418 14.9054 19.0303 14.6595 19.1963C14.4408 19.3623 9.8497 19.639 9.38512 19.4176C8.89321 19.1686 5.85977 16.2635 5.61382 15.9039C5.39519 15.5442 4.84863 11.0344 5.03992 10.4534C5.20389 9.87234 8.97519 5.69455 9.33046 5.58388ZM15.7799 16.0975C16.0805 15.7655 15.8619 11.5877 15.7799 11.3387C15.7253 11.062 13.0744 8.73797 12.6918 8.51663C12.3366 8.29529 8.21 8.40596 7.99138 8.71031C7.60878 9.20832 8.07336 13.1924 8.26466 13.5798C8.45596 13.9948 10.8882 16.0975 11.3528 16.3742C11.79 16.6785 15.5067 16.4295 15.7799 16.0975Z'
              fill='#1D1D1D'
            />
          </svg>
        </span>
        <span className='side-text__erugo'>/ erugo.gada</span>
      </a>
    </aside>
  );
}

export default SideText;
